<template>
  <div id="preview" class="stage preview-stage">
    <header class="preview">
      <div class="bg" style="background-image: url(https://feuerwerk.rewe.de/backend/assets/headers/Q4_Feuerwerk_Headerimage_1920x1024-Startseite.jpg)"></div>
    </header>
    <div class="main preview dark-curved-bg">
      
      <div class="preview-copy" v-if="showHint">
        <h1>REWE Feuerwerk {{ currentYear }}</h1>
        <div class="preview-info">
          <i class="icon-info circle" aria-hidden="true"></i><span>Der Verkauf ist vorbei, doch die Vorfreude bleibt! Schau dir an, welche Lichter heute Abend in den Himmel steigen.</span>
        </div>
      </div>
      
      <div class="preview-copy" v-else>
        
        <h1>REWE Feuerwerk {{ currentYear }}</h1>
        
        <div class="countdown-headline">Der Countdown läuft! Der Verkauf startet in</div>
        
        <Countdown :countdown-date="countdownDatetime.format()" :preview="true" />
        
      </div>
      
      <div class="visually-hidden">
        <h2>Entdecke die beliebtesten Produkte aus dem letzten Jahr</h2>
        <ul>
          <li v-for="product in highlightProducts"
        :key="product.id"
        >{{ `${product.title} (Kategorie: ${product.categories[0]})` }}</li>
        </ul>
      </div>
      
      <section class="preview-products-carousel-stage" aria-hidden="true">
          <div class="header-container">
            <img src="/assets/images/weco-logo.png" class="weco" alt="Icon WeCo" />
            <h2 v-if="!showHint">
              Entdecke die beliebtesten Produkte aus dem letzten Jahr
            </h2>
            <div class="slider-pagination desktop">
              <ul>
                <li :class="{ active: activeSlide === 0 }"></li>
                <li :class="{ active: activeSlide === 1 }"></li>
                <li :class="{ active: activeSlide === 2 }"></li>
                <li :class="{ active: activeSlide === 3 }"></li>

                <li :class="{ mobile: true, active: activeSlide === 4 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 5 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 6 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 7 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 8 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 9 }"></li>
              </ul>
            </div>
          </div>

          <div class="carousel-container" aria-hidden="true">
            <carousel
              :perPage="1"
              :centerMode="true"
              :perPageCustom="[[900, 3]]"
              :paginationEnabled="false"
              :navigationEnabled="true"
              navigationNextLabel=""
              navigationPrevLabel=""
              @pageChange="onPageChange"
              aria-label="Beliebteste Produkte"
            >
              <Slide
                v-for="product in highlightProducts"
                :key="product.id"
              >
                <ProductsListItem
                  :product="product"
                  :detailLink="false"
                  :preview="true"
                  @openVideo="openVideo"
                />
              </Slide>
            </carousel>
            <div class="slider-pagination mobile">
              <ul>
                <li :class="{ active: activeSlide === 0 }"></li>
                <li :class="{ active: activeSlide === 1 }"></li>
                <li :class="{ active: activeSlide === 2 }"></li>
                <li :class="{ active: activeSlide === 3 }"></li>

                <li :class="{ mobile: true, active: activeSlide === 4 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 5 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 6 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 7 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 8 }"></li>
                <li :class="{ mobile: true, active: activeSlide === 9 }"></li>
              </ul>
            </div>
          </div>
      </section>
    </div>
    
    <div class="outro-stage light-curved-bg">
      <div class="teaser-container">
        <a
          href="https://www.rewe.de/ernaehrung/silvester/?icid=rewe|ak|sale|n|Q4-25-Feuerwerksverkauf-2025-M_rewe-de:feuerwerk2025:start_int_content_rewe-de:ernaehrung:silvester_nn_nn_nn_nn"
          target="_blank"
          class="col recipes alone"
          aria-label="Dein perfekter Start ins neue Jahr - Entdecke tolle Ideen für ein schönes Silvester im kleinen Kreis."
        >
          <div class="image"></div>
          <div class="content dark-curved-bg">
            <h6>Dein perfekter Start ins neue Jahr</h6>
            <p>Entdecke tolle Ideen für ein schönes Silvester im kleinen Kreis.</p>
            <button class="button-primary" aria-label="Zu Rezepten und mehr" tabindex="-1" aria-hidden="true">
              <i class="icon-kueche" aria-hidden="true"></i> Zu Rezepten und mehr
            </button>
          </div>
        </a>
      </div>

    </div>
    
    <FooterComponent :preview="true" />
    
  </div>
</template>

<script>
import Countdown from "@/components/CountdownTimer";
import { Carousel, Slide } from "vue-carousel";
import ProductsListItem from "@/components/ProductsListItem";
import HomeOutro from "@/components/HomeOutro";
import FooterComponent from "@/components/Footer";
import config from "@/config";
import highlightProducts from "@/highlightProducts";
import moment from "moment";
export default {
  name: "preview",
  components: {
    Countdown,
    Carousel,
    Slide,
    ProductsListItem,
    HomeOutro,
    FooterComponent
  },
  data(){
    return {
      activeSlide: 0
    }
  },
  mounted() {
    this.$trackPageView({ name: ":startseite", hierarchy: [] });
  },
  methods: {
    onPageChange(nr) {
      this.activeSlide = nr;
    },
    openVideo(youtubeId) {
      this.$emit("openVideo", youtubeId);
    },
  },
  computed: {
    currentYear() {
      return moment().format("Y");
    },
    showHint(){
      if (this.$route.meta.hint) {
        return true
      } else {
        return false
      }
    },
    countdownDatetime() {
      return config.saleStart;
    },
    highlightProducts() {
      console.log(highlightProducts);
      return highlightProducts;
    }
  }
};
</script>

<style lang="scss">
@import "./Preview";
</style>
